export default "__VITE_ASSET__DMe3CPdX__"